export default __webpack_public_path__ + "static/media/rio_santiago_subcuencas.ebc3b18c.zip";